import React from "react";
import "./Hero.scss";

const Hero = () => {
    return (
        <section className="hero" aria-labelledby="hero-title">
            <div className="hero__inner">
                <div className="hero__content">
                    <p className="hero__eyebrow">Technology. Partnerships. Ventures.</p>

                    <h1 id="hero-title">
                        <span>We Build.</span>
                        <span>We Connect.</span>
                        <span className="hero__accent">We Innovate.</span>
                    </h1>

                    <p className="hero__description">
                        We engineer digital solutions, develop technology-driven ventures,
                        and connect international businesses with emerging opportunities
                        across Africa.
                    </p>

                    <div className="hero__actions">
                        <a className="hero__button hero__button--primary" href="#what-we-build">
                            Explore Our Solutions
                            <span aria-hidden="true">↗</span>
                        </a>

                        <a className="hero__button hero__button--secondary" href="/invest-africa">
                            Discover Invest Africa
                            <span aria-hidden="true">→</span>
                        </a>
                    </div>
                </div>

                <div className="hero__visual" aria-label="Techadive's areas of focus">
                    <div className="hero__orbit" aria-hidden="true" />

                    <ul className="hero__panels">
                        <li className="hero__panel hero__panel--technology">
              <span className="hero__panel-icon" aria-hidden="true">
                {"</>"}
              </span>
                            <p className="hero__panel-category">Build</p>
                            <h2>Technology Solutions</h2>
                            <p>Software &amp; Digital Engineering</p>
                            <div className="hero__panel-lines" aria-hidden="true">
                                <span />
                                <span />
                                <span />
                            </div>
                        </li>

                        <li className="hero__panel hero__panel--africa">
                            <span className="hero__panel-icon" aria-hidden="true">↗</span>
                            <p className="hero__panel-category">Connect</p>
                            <h2>Invest Africa</h2>
                            <p>International Partnerships &amp; Market Entry</p>
                        </li>

                        <li className="hero__panel hero__panel--ventures">
                            <span className="hero__panel-icon" aria-hidden="true">✦</span>
                            <p className="hero__panel-category">Innovate</p>
                            <h2>Our Ventures</h2>
                            <p>Products Built by Techadive</p>
                        </li>
                    </ul>
                </div>
            </div>
        </section>
    );
};

export default Hero;